import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, Modal, Stack, Typography } from "@mui/material";

import MeetingMetricPreview from "@app/analytics/assets/meeting_metric_preview.png";
import usePreloadImages from "@app/common/hooks/usePreloadImages";

const ReadAssistantPreviewModal = ({
  onClose,
  open,
}: {
  onClose: () => void;
  open: boolean;
}) => {
  const loaded = usePreloadImages([MeetingMetricPreview]);

  return (
    <Modal open={loaded && open} onClose={onClose}>
      <Stack
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "803px",
          transform: "translate(-50%, -50%)",
          background: "white",
          borderRadius: "8px",
          p: 4,
          maxHeight: "95%",
          maxWidth: "95%",
        }}
      >
        <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
          <Typography variant="h3">Read Assistant View Comparison</Typography>
          <CloseIcon sx={{ cursor: "pointer", ml: "auto" }} onClick={onClose} />
        </Stack>
        <Box
          component="img"
          src={MeetingMetricPreview}
          sx={{ width: "100%" }}
        />
      </Stack>
    </Modal>
  );
};

export default ReadAssistantPreviewModal;
